export function resolveCloseAction(quantity) {
    const numericQuantity = Number(quantity);
    if (!Number.isFinite(numericQuantity) || numericQuantity === 0) {
        return null;
    }

    return {
        side: numericQuantity > 0 ? 'SELL' : 'BUY',
        absoluteQuantity: Math.abs(Math.round(numericQuantity)),
    };
}
